import React from "react";
import "./BonusGuarantees.css";

const bonusItems = [
  {
    icon: "💰",
    title: "6-Month Free Trial",
    subtitle: "No upfront fees",
  },
  {
    icon: "✅",
    title: "Continued Support",
    subtitle: "If no sales",
  },
  {
    icon: "🏆",
    title: "Sales Guarantees",
    subtitle: "In Standard & Enterprise",
  },
  {
    icon: "🎁",
    title: "Free Market Guide",
    subtitle: "On signup",
  },
];

const BonusGuarantees = () => {
  return (
    <section className="bonus-section">
      <div className="bonus-container">
        <h2 className="bonus-heading">
          Start With Confidence—<span>Our Guarantee to You</span>
        </h2>

        <div className="bonus-grid">
          {bonusItems.map((item, index) => (
            <div className="bonus-card" key={index}>
              <div className="bonus-icon">{item.icon}</div>
              <h4>{item.title}</h4>
              <p>{item.subtitle}</p>
            </div>
          ))}
        </div>

        {/* <div className="bonus-button-wrap">
          <button className="bonus-button">Get the Free Guide</button>
        </div> */}
      </div>
    </section>
  );
};

export default BonusGuarantees;
